// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert-auth-callback[data-v-99f9c6b0]{display:flex;padding:12px 20px;border-radius:3.2px;margin-bottom:16px}", ""]);
// Exports
module.exports = exports;
